import api from '../../helper/api';
import { UserRole } from '../../helper/Utils';
import { USER_LOADED, USER_FAIL, LOGIN_SUCCESS, LOGOUT, ERROR_USER_DETAILS } from './constants';
import setAuthToken from '../../helper/setAuthToken';



//Load login User
// export const loadUser = () => async dispatch => {
//     const config = {
//         header: {
//             'Content-Type': 'application/json'
//         }
//     }
//     try {
//         const response = await api.get(`/admin`, config);
//         dispatch({
//             type: USER_LOADED,
//             payload: response.data
//         });
//         dispatch(loadUser());
//     } catch (err) {
//         const error = err.response.data
//         if (error) {
//             // dispatch(setAlert(error.msg, 'danger'));
//         }
//         dispatch({
//             type: USER_FAIL
//         });
//     }

// }


//Load login User
export const loadUser = () => async dispatch => {
    try {
        const resp = await api.get(`/admin`);
        global.org_role = resp.data.type;
        dispatch({
            type: USER_LOADED,
            payload: {
                id: 1,
                name: resp.data.adminID,
                role: UserRole[resp.data.type],
                type: resp.data.type // Include this for org_role mapping
            }
        });
    }
    catch (err) {
        console.error('Load user error:', err);
        const error = err.response?.data || { msg: 'Failed to load user' };
        if (error) {
            // dispatch(setAlert(error.msg, 'danger'));
        }
        dispatch({
            type: USER_FAIL
        });
    }
}

//Login API
export const login = (adminID, password) => async dispatch => {
    const config = {
        header: {
            'Content-Type': 'application/json'
        }
    }
    const body = {
        adminID,
        password
    }
    try {
        console.log('Attempting login for:', adminID);
        const response = await api.post(`/admin/login`, body, config);
        console.log('Login response:', response.data);

        // Set auth token in localStorage and axios headers
        setAuthToken(response.data.token);

        // Set global role for sidebar before dispatching loadUser
        global.org_role = response.data.role;

        dispatch({
            type: LOGIN_SUCCESS,
            payload: response.data
        });
        dispatch(loadUser());
    } catch (err) {
        console.error('Login error:', err);
        const errorData = err.response?.data || { msg: 'Login failed. Please try again.' };
        dispatch({
            type: ERROR_USER_DETAILS,
            payload: errorData
        });
    }
}

//LOGOUT 
export const logout = () => async dispatch => {
    try {
        // Call server to log the logout activity
        await api.post('/admin/logout');
    } catch (err) {
        // Even if server call fails, proceed with local logout
        console.error('Logout API error:', err);
    }
    
    // Clear all auth data from localStorage
    const { clearAuthData } = require('../../helper/tokenUtils');
    clearAuthData();
    
    // Clear auth token from axios headers
    setAuthToken(null);

    dispatch({
        type: LOGOUT
    });
}